import * as types from './actionTypes';

import { fetchContent } from './common';
import * as userActions from './userActions';

const config = window.weftConfig;


function getHeroData() {
  return {
    type: types.GET_HERO_DATA,
  };
}

function receiveHeroData(data) {
  return {
    type: types.RECEIVE_HERO_DATA,
    data,
  };
}

function getHeroDataError(error) {
  return {
    type: types.GET_HERO_DATA_ERROR,
    error,
  }
}

export function fetchIndexHero() {
  return fetchContent('/home-page/', getHeroData, receiveHeroData, getHeroDataError, false);
  // const homePageEndpoint = '/home-page';
  // return (dispatch, getState) => {
  //   dispatch(getHeroData());
  //   return fetch(apiRoot + homePageEndpoint)
  //     .then(response => response.json())
  //     .then(data => dispatch(receiveHeroData(data)))
  //     .catch(err => dispatch(getHeroDataError(err)));
  // };
}

export function fetchShopHero() {
  return fetchContent('/shop-page/', getHeroData, receiveHeroData, getHeroDataError, false);
  // const shopPageEndpoint = '/shop-page';
  // return (dispatch, getState) => {
  //   dispatch(getHeroData());
  //   return fetch(apiRoot + shopPageEndpoint)
  //     .then(response => response.json())
  //     .then(data => dispatch(receiveHeroData(data)))
  //     .catch(err => dispatch(getHeroDataError(err)));
  // };
}

function getFabricData() {
  return {
    type: types.GET_FABRIC_DATA,
    isFetching: true,
  };
}

function receiveFabricData(data) {
  return {
    type: types.RECEIVE_FABRIC_DATA,
    isFetching: false,
    data,
  };
}

function getFabricDataError(error) {
  return {
    type: types.GET_FABRIC_DATA_ERROR,
    error
  };
}

export function fetchFabricData(fabric_id = null) {
  let fabricEndpoint = fabric_id ? `/fabric/${fabric_id}/` : '/fabric/';
  return fetchContent(fabricEndpoint, getFabricData, receiveFabricData, getFabricDataError, false);
  // return (dispatch, getState) => {
  //   dispatch(getFabricData());
  //   return fetch(apiRoot + fabricEndpoint)
  //     .then(response => response.json())
  //     .then(data => dispatch(receiveFabricData(data)))
  //     .catch(err => dispatch(getFabricDataError(err)));
  // };
}

function getColorwayData() {
  return {
    type: types.GET_COLORWAY_DATA,
    isFetching: true,
  };
}

function receiveColorwayData(data) {
  return {
    type: types.RECEIVE_COLORWAY_DATA,
    isFetching: false,
    data,
  };
}

function getColorwayDataError(error) {
  return {
    type: types.GET_COLORWAY_DATA_ERROR,
    error
  };
}

export function fetchColorwayData(colorway_id = null) {
  let colorwayEndpoint = colorway_id ? `/colorway/${colorway_id}/` : '/colorway/';
  return fetchContent(colorwayEndpoint, getColorwayData, receiveColorwayData, getColorwayDataError, false);
  // return (dispatch, getState) => {
  //   dispatch(getColorwayData());
  //   return fetch(apiRoot + colorwayEndpoint)
  //   .then(response => response.json())
  //   .then(data => dispatch(receiveColorwayData(data)))
  //   .catch(err => dispatch(getColorwayDataError(err)));
  // };
}

function getSymmetryFabricData() {
  return {
    type: types.GET_SYMMETRY_FABRIC_DATA,
    isFetching: true,
  };
}

function receiveSymmetryFabricData(data) {
  return {
    type: types.RECEIVE_SYMMETRY_FABRIC_DATA,
    isFetching: false,
    data,
  };
}

function getSymmetryFabricDataError(error) {
  return {
    type: types.GET_SYMMETRY_FABRIC_DATA_ERROR,
    error
  };
}

export function fetchSymmetryFabricData(fabric_id = null) {
  let fabricEndpoint = fabric_id ? `/s-fabric/${fabric_id}/` : '/s-fabric/';
  return fetchContent(fabricEndpoint, getFabricData, receiveFabricData, getFabricDataError, false);
  // return (dispatch, getState) => {
  //   dispatch(getFabricData());
  //   return fetch(apiRoot + fabricEndpoint)
  //     .then(response => response.json())
  //     .then(data => dispatch(receiveFabricData(data)))
  //     .catch(err => dispatch(getFabricDataError(err)));
  // };
}

function getSymmetryColorwayData() {
  return {
    type: types.GET_SYMMETRY_COLORWAY_DATA,
    isFetching: true,
  };
}

function receiveSymmetryColorwayData(data) {
  return {
    type: types.RECEIVE_SYMMETRY_COLORWAY_DATA,
    isFetching: false,
    data,
  };
}

function getSymmetryColorwayDataError(error) {
  return {
    type: types.GET_SYMMETRY_COLORWAY_DATA_ERROR,
    error
  };
}

export function fetchSymmetryColorwayData(colorway_id = null) {
  let colorwayEndpoint = colorway_id ? `/s-colorway/${colorway_id}/` : '/s-colorway/';
  return fetchContent(colorwayEndpoint, getColorwayData, receiveColorwayData, getColorwayDataError, false);
  // return (dispatch, getState) => {
  //   dispatch(getColorwayData());
  //   return fetch(apiRoot + colorwayEndpoint)
  //   .then(response => response.json())
  //   .then(data => dispatch(receiveColorwayData(data)))
  //   .catch(err => dispatch(getColorwayDataError(err)));
  // };
}


function getProductData() {
  return {
    type: types.GET_PRODUCT_DATA,
    isFetching: true,
  };
}

function receiveProductData(data) {
  return {
    type: types.RECEIVE_PRODUCT_DATA,
    isFetching: false,
    data,
  };
}

function getProductDataError(error) {
  return {
    type: types.GET_PRODUCT_DATA_ERROR,
    error
  };
}

export function fetchProductData(product_id = null) {
  let productEndpoint = product_id ? `/product/${product_id}/` : '/product/';
  return fetchContent(productEndpoint, getProductData, receiveProductData, getProductDataError, false);
  // return (dispatch, getState) => {
  //   dispatch(getProductData());
  //   return fetch(apiRoot + productEndpoint)
  //     .then(response => response.json())
  //     .then(data => dispatch(receiveProductData(data)))
  //     .catch(err => dispatch(getProductDataError(err)));
  // };
}


// Qualities
function getShopQualityData() {
  return {
    type: types.GET_SHOP_QUALITY_DATA,
  };
}

function receiveShopQualityData(data) {
  return {
    type: types.RECEIVE_SHOP_QUALITY_DATA,
    data,
  };
}

function getShopQualityDataError(error) {
  return {
    type: types.GET_SHOP_QUALITY_DATA_ERROR,
    error,
  }
}

export function fetchShopQualities() {
  let qualitiesEndpoint = '/qualities/';
  return fetchContent(qualitiesEndpoint, getShopQualityData, receiveShopQualityData, getShopQualityDataError, false);
  // return (dispatch, getState) => {
  //   dispatch(getShopQualityData());
  //   return fetch(apiRoot + qualitiesEndpoint)
  //     .then(response => response.json())
  //     .then(data => dispatch(receiveShopQualityData(data)))
  //     .catch(err => dispatch(getShopQualityDataError(err)));
  // };
}


/*
 *   Update shop UI state
 */

function updateSortAction(sort_value) {
  return {
    type: types.SHOP_UPDATE_SORT,
    sort_value
  };
}

export function updateSort(sort_value) {
	return (dispatch, getState) => {
		dispatch(updateSortAction(sort_value));
  };
}

function setProductDetailImageAction(image) {
  return {
    type: types.SHOP_SET_PRODUCT_DETAIL_IMAGE,
    image
  };
}

export function setProductDetailImage(image) {
  return (dispatch, getState) => {
    dispatch(setProductDetailImageAction(image));
  };
}

function setDetailImageAction(image) {
  return {
    type: types.SHOP_SET_DETAIL_IMAGE,
    image
  };
}

export function setDetailImage(image) {
	return (dispatch, getState) => {
		dispatch(setDetailImageAction(image));
  };
}

function setSelectedColorwayAction(colorway) {
  return {
    type: types.SHOP_SET_SELECTED_COLORWAY,
    colorway
  };
}

export function setSelectedColorway(colorway) {
  return (dispatch, getState) => {
    dispatch(setSelectedColorwayAction(colorway));
  };
}

function rotateFabricImageAction(ccw) {
  return {
    type: types.SHOP_ROTATE_FABRIC_IMAGE,
    ccw
  };
}

export function rotateFabricImage(ccw) {
  return (dispatch, getState) => {
    dispatch(rotateFabricImageAction(ccw));
  };
}


function clearFiltersAction() {
  return {
    type: types.SHOP_CLEAR_FILTERS,
  };
}

export function clearFilters() {
  return (dispatch, getState) => {
    dispatch(clearFiltersAction());
  };
}


function setFilterAction(filter) {
  return {
    type: types.SHOP_SET_FILTER,
    filter: filter.toUpperCase(),
  };
}

export function setFilter(filter) {
  return (dispatch, getState) => {
    dispatch(setFilterAction(filter));
  };
}


function unsetFilterAction(filter) {
  return {
    type: types.SHOP_UNSET_FILTER,
    filter: filter.toUpperCase(),
  };
}

export function unsetFilter(filter) {
  return (dispatch, getState) => {
    dispatch(unsetFilterAction(filter));
  };
}

export function hideAnnouncement() {
  return {
    type: types.HIDE_ANNOUNCEMENT,
  };
}
